import { TFunction } from "react-i18next";
import { PasswordComplexity } from "../models/PasswordComplexity";

interface IGenericValidationCriteria {
  usernameMinLength: number;
  usernameMaxLength: number;
}

const criteria: IGenericValidationCriteria = {
  usernameMinLength: 5,
  usernameMaxLength: 50,
};

export const genericValidation = (
  placeholder: string,
  value: string,
  t: TFunction,
  minLength: number = criteria.usernameMinLength,
  maxLength: number = criteria.usernameMaxLength,
): string | null => {
  if (!value.length) {
    return null;
  }

  if (value.length < minLength) {
    return t("validationUsernameMinLength", {
      placeholder: placeholder,
      length: criteria.usernameMinLength,
    });
  }
  if (value.length > maxLength) {
    return t("validationUsernameMaxLength", { placeholder: placeholder });
  }

  return null;
};

export const validateEmail = (email: string): boolean => {
  const validEmailPatttern =
  // eslint-disable-next-line
    /^[a-zA-Z0-9!#$%&'*+\/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+\/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$/;
  return validEmailPatttern.test(email);
};

export const validatePasswordComplexity = (
  passwordComplexity: PasswordComplexity | undefined,
  password: string,
): boolean => {
  if (
    passwordComplexity == null ||
    passwordComplexity.validationExpressions == null ||
    passwordComplexity.validationExpressions.length === 0
  ) {
    return false;
  }

  for (const item of passwordComplexity.validationExpressions) {
    const pattern = regExpFromString(item.expression);
    if (pattern == null || pattern.test(password) === false) {
      return false;
    }
  }

  return true;
};

function regExpFromString(expression: string): RegExp | null {
  let flags = expression.replace(/.*\/([gimuy]*)$/, "$1");
  if (flags === expression) {
    flags = "";
  }
  const pattern = flags ? expression.replace(new RegExp("^/(.*?)/" + flags + "$"), "$1") : expression;
  try {
    return new RegExp(pattern, flags);
  } catch (e) {
    return null;
  }
}
